import Glide from '@glidejs/glide'
import '@glidejs/glide/dist/css/glide.core.min.css'
import youTubePlayer from 'youtube-player'
import DefaultRenderer from './Default'
import { qs } from '../../utils'

class NewHomePageRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  // TODO: do more research on headless disclosure for JS, should support keyboard navigation
  addFAQsToggleHandlers() {
    const faqElementsMapping = Array.from(document.querySelectorAll('[data-js^="faq-"]'))
    const faqElements = []

    for (let i = 0; i < faqElementsMapping.length; i += 3) {
      const section = faqElementsMapping[i]
      const arrow = faqElementsMapping[i + 1]
      const answer = faqElementsMapping[i + 2]
      faqElements.push({ section, arrow, answer })
    }

    faqElements.forEach(({ section, answer, arrow }) => {
      /**
       * set data attribute used for analytic tracking to match the arrow icon direction
       * @param {'^' | 'v'} direction
       */
      const setArrowDataComponent = (direction) => arrow.setAttribute('data-component', direction)

      /**
       * @see https://learn.microsoft.com/en-us/windows/win32/uxguide/ctrl-progressive-disclosure-controls?redirectedfrom=MSDN#design_concepts for info on arrow direction and accordion state
       */
      const toggleArrow = () => {
        const arrowIsUp = arrow.classList.contains('tw-rotate-180')
        if (arrowIsUp) {
          setArrowDataComponent('v')
          return arrow.classList.remove('tw-rotate-180')
        }
        setArrowDataComponent('^')
        return arrow.classList.add('tw-rotate-180')
      }
      const toggleAnswer = () => {
        if (answer.classList.contains('tw-hidden')) return answer.classList.remove('tw-hidden')
        return answer.classList.add('tw-hidden')
      }
      section.addEventListener('click', () => {
        toggleArrow()
        toggleAnswer()
      })
    })
  }

  mountYoutubeVideo() {
    const iframe = document.querySelector('iframe')
    const player = youTubePlayer(iframe)

    /**
     * @see https://developers.google.com/youtube/iframe_api_reference#Events
     */
    const playerStateMap = {
      '-1': 'unstarted',
      0: 'ended',
      1: 'playing',
      2: 'paused',
      3: 'buffering',
      5: 'video cued',
    }

    player.on('stateChange', (event) => {
      const playerState = playerStateMap[event.data]

      if (!playerState) {
        throw new Error('Unknown state (' + event.data + ').')
      }

      if (playerState === 'playing') {
        super.trackUserInteractionWithElement({
          elementName: iframe.dataset.track,
          component: iframe.dataset.component,
        })
      }
    })
  }

  mountCarousel() {
    const glide = new Glide('.glide', {
      type: 'carousel',
      autoplay: 7 * 1000,
    })

    glide.on('move', () => {
      const glideBullets = document.querySelectorAll('.glide__bullet')
      glideBullets.forEach((glideBullet, index) => {
        if (glide.index === index) {
          glideBullet.classList.add('tw-bg-black')
          glideBullet.classList.remove('tw-bg-transparent')
        } else {
          glideBullet.classList.add('tw-bg-transparent')
          glideBullet.classList.remove('tw-bg-black')
        }
      })
    })

    glide.mount()
  }

  mountScrollingQuotes() {
    const waitTime = 3000
    const transitionTime = 500
    const topPercentages = [-50, 0, 50, 100, 150]

    const carouselItems = document.querySelectorAll('[data-js="carousel-item"]')
    const maxItems = carouselItems.length

    carouselItems.forEach((carouselItem, index) => {
      const keyframeGroups = Array.from(Array(maxItems + 1).keys()).map((keyIndex) => {
        const framePosition = (index - keyIndex + maxItems) % maxItems

        const top = `${topPercentages[framePosition]}%`
        const opacity = framePosition === (maxItems - 1) / 2 ? 1 : 0.3

        if (keyIndex === maxItems) {
          return {
            top,
            opacity,
            offset: 1,
          }
        }

        return [
          {
            top,
            opacity,
            easing: framePosition === maxItems - 1 ? 'step-end' : 'ease-in-out',
            offset: keyIndex * (1 / maxItems),
          },
          {
            top,
            opacity,
            easing: framePosition === 0 ? 'step-start' : 'ease-in-out',
            offset: (1 / maxItems) * (keyIndex + waitTime / (transitionTime + waitTime)),
          },
        ]
      })

      carouselItem.animate(keyframeGroups.flat(), {
        duration: (transitionTime + waitTime) * (maxItems + 1),
        iterations: Infinity,
        fill: 'both',
      })
    })
  }

  // attachBannerCloseHandler() {
  //   qs('[data-js=close]').addEventListener('click', function () {
  //     // TODO: Remove jQuery and use css/js combination to do animation
  //     $('#home-page-banner').slideUp()
  //   })
  // }

  onEnterCompleted() {
    super.onEnterCompleted()
    // this.attachBannerCloseHandler()
    this.addFAQsToggleHandlers()
    this.mountYoutubeVideo()
    this.mountCarousel()
    this.mountScrollingQuotes()
  }
}

export default NewHomePageRenderer
